<template lang="pug">
b-button.mt-1.mb-1( variant="outline-info" class="mr-2" size="sm" v-on="$listeners" )
  b-icon( :icon="icon" small )
  span( v-if="$slots.default" class="ml-1")
    slot
</template>

<script>
export default {
  props: ['type'],

  computed: {
    icon() {
      switch (this.type) {
        case 'add':
          return 'plus-circle'

        case 'edit':
          return 'pencil'

        case 'remove':
          return 'x-circle'

        case 'filter':
          return 'funnel'
        
        case 'people-add':
          return 'person-plus'

        case 'people-dash':
          return 'person-dash'  

        case 'download':
          return 'file-earmark-arrow-down' 

        case 'stopEditable': 
          return 'slash-circle'
        
        case 'checkProfile': 
          return 'journals'
        default:
          return ''
      }
    }
  },
}
</script>